import type { RouteObject } from 'react-router';

import * as embedSearchVolopsHorizonRouteExports from '#/modules/embedSearchWidget/volops/pages/search/EmbedSearchWidgetSearchVolops.horizon-route';
import * as embedViewVolopHorizonRouteExports from '#/modules/embedSearchWidget/volops/pages/view/EmbedSearchWidgetViewVolop.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import {
  embedSearchWidgetSearchVolopsRoute,
  embedSearchWidgetViewVolopRoute,
  embedSearchWidgetVolopsRouteGroup,
} from './embedSearchWidgetVolops.routes';

export const embedSearchWidgetVolopsRouteObjects = [
  {
    path: embedSearchWidgetVolopsRouteGroup.path,
    children: [
      {
        path: embedSearchWidgetSearchVolopsRoute.relativePath,
        ...horizonRouteToObject(embedSearchVolopsHorizonRouteExports),
      },
      {
        path: embedSearchWidgetViewVolopRoute.relativePath,
        ...horizonRouteToObject(embedViewVolopHorizonRouteExports),
      },
    ],
  },
] satisfies RouteObject[];
